import { Form } from '@spritz-finance/ui'
import { RegisterOptions } from 'react-hook-form'

export const PaymentAmountInput = ({
    disabled = false,
    validation,
    type = 'number',
}: {
    disabled?: boolean
    validation: RegisterOptions
    type?: string
}) => {
    return (
        <Form.Input
            type={type}
            name="amount"
            min={0}
            floatingPlaceholder={false}
            disabled={disabled}
            validation={validation}
            placeholder="0.00"
            fontSize={28}
            validationMessage="Amount must be greater than zero"
            step={0.01}
            style={{ paddingLeft: 0, marginLeft: 24 }}
        />
    )
}
